<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yTqjxe/tc-custom/9781504057585.jpg?1736611017213" alt="This image is the cover for the book Selected Works"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Selected Works
      </h1>
      <p class="bookDescription body article font2">
        <b>Two novels and two collections of poetry, all powerful reflections on the AIDS experience, from the National Book Award–winning author of <i>Becoming a Man</i>.</b><br/>  <br/><i>Afterlife</i>: Three men bond after their lovers die of AIDS, all within a week of one another in the same Los Angeles hospital. Each of the men react differently to the situation he’s in, but no matter the path each takes, they are all searching for a way to live and love again.<br/>  <br/><i>Halfway Home</i>: After being diagnosed with AIDS, Tom moves to a California beach house to live out the rest of his life in peace. But the unexpected reappearance of his troubled brother quickly changes everything in this novel about anger, reconciliation, love, and danger.<br/>  <br/><i>Love Alone</i>: Following his partner Roger Horwitz’s death from AIDS in 1986, Paul Monette threw himself into these elegies. Writing them, he says, “quite literally kept me alive.” Both beautifully written and deeply affecting, every poem is full of resentment, sorrow, tenderness, and a palpable sense of grief—but also love.<br/>  <br/><i>West of Yesterday, East of Summer</i>: This stunning career-spanning collection includes Monette’s early work as well as the beautiful and wrenching poems borne out of immense loss. Written with characteristic wit, these poems deftly traverse humor, rage, love, and mourning.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Monette
      </h2>
      
      <p class="authorDescription body article">Paul Monette (1945&ndash;1995) was an author, poet, and gay rights activist. Born in Massachusetts and educated at Yale University, he moved with his partner Roger Horwitz to Los Angeles in 1978 and became involved in the gay rights movement. Monette&rsquo;s writing captures the sense of heartbreak and loss at the center of the AIDS crisis. His first novel, <I>Taking Care of Mrs. Carroll</I>, was published in 1978, and he went on to write several more works of fiction, poetry, and memoir. <I>Borrowed Time: An AIDS Memoir</I>, the tender account of his partner&rsquo;s battle with the disease, earned him both PEN Center West and Lambda literary awards. In 1992, Monette won the National Book Award in Nonfiction for <I>Becoming a Man: Half a Life Story</I>, an autobiography detailing his early life and his struggle with his sexuality. Written as a classic coming-of-age story, <I>Becoming a Man</I> became a seminal coming-out story. In 1995, Monette founded the Monette-Horwitz Trust, which honors individuals and organizations working to combat homophobia. Monette died in his home in West Hollywood in 1995 of complications from AIDS.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3109dd42